import i18n from "i18next";
import { z } from "zod";

/**
 * Zod 4 ships its own translated error maps, so the `zod-i18n-map` package (and
 * the i18next `zod` namespace it needed) is no longer involved. Only the
 * languages the app actually offers are wired up; anything else falls back to
 * the same language i18next falls back to.
 */
const locales = {
	en: z.locales.en,
	fr: z.locales.fr,
};

const applyLocale = (language: string | undefined) => {
	const [base] = (language ?? "en").split("-");
	z.config((locales[base as keyof typeof locales] ?? locales.en)());
};

applyLocale(i18n.language);
i18n.on("languageChanged", applyLocale);

export { z };
